"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _iterables = require("rich-text-lib/utils/iterables");

var _AlignmentMenu = _interopRequireDefault(require("rich-text-lib/components/formatting/AlignmentMenu"));

var _hsformatting = require("../../constants/hsformatting");

var TinyMceAlignMenu =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(TinyMceAlignMenu, _Component);

  function TinyMceAlignMenu(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TinyMceAlignMenu);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TinyMceAlignMenu).call(this, props));
    _this.handleFormatChange = _this.handleFormatChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      alignment: props.getlastAlign()
    };
    return _this;
  }

  (0, _createClass2.default)(TinyMceAlignMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.editor.on(this.formatEvents.join(' '), this.handleFormatChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.editor.off(this.formatEvents.join(' '), this.handleFormatChange);
    }
  }, {
    key: "handleFormatChange",
    value: function handleFormatChange(_ref) {
      var format = _ref.format,
          isActive = _ref.isActive;
      var alignOptions = this.props.alignOptions;
      var matched = Object.keys(alignOptions).find(function (option) {
        return format.match(alignOptions[option]);
      });
      var alignment = alignOptions[matched];

      if (isActive) {
        this.setState({
          alignment: alignment
        });
      } else if (this.state.alignment === alignment) {
        this.setState({
          alignment: alignOptions.LEFT
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      this.props.setlastAlign(this.state.alignment);
      return _react.default.createElement(_AlignmentMenu.default, (0, _extends2.default)({}, this.state, (0, _iterables.omit)(Object.keys(TinyMceAlignMenu.propTypes), this.props), {
        tooltip: _I18n.default.text(_hsformatting.i18nNameSpace + ".tooltip.align"),
        alignOptions: this.props.alignOptions
      }));
    }
  }, {
    key: "formatEvents",
    get: function get() {
      return this.props.formats.map(function (format) {
        return "FormatChanged:" + format;
      });
    }
  }]);
  return TinyMceAlignMenu;
}(_react.Component);

exports.default = TinyMceAlignMenu;
TinyMceAlignMenu.propTypes = {
  editor: _react.PropTypes.object.isRequired,
  alignOptions: _react.PropTypes.shape({
    CENTER: _react.PropTypes.string,
    LEFT: _react.PropTypes.string,
    RIGHT: _react.PropTypes.string,
    FULL: _react.PropTypes.string
  }),
  formats: _react.PropTypes.arrayOf(_react.PropTypes.string).isRequired,
  setlastAlign: _react.PropTypes.func.isRequired,
  getlastAlign: _react.PropTypes.func.isRequired
};
module.exports = exports.default;